import { useEffect } from 'react'
import { FlexRow, MultiSwitch } from '@epam/loveship'
import { amplTrack } from '@stlm/common-ui/lib'
import { useActions } from '../../../../hooks/redux/actions'
import { useAppSelector } from '../../../../hooks/redux/redux'
import { useGetCategoriesQuery } from '../../../../store'
import { useSideBarControlls } from '../../../../hooks/useSideBarControlls'
import { NewEventForm } from './components/NewEventForm/NewEventForm'
import { EventInfo } from './components/EventInfo/EventInfo'
import { EventEditForm } from './components/EventEditForm/EventEditForm'
import { getExtendedEvent } from '../../../../utils/common/getExtendedEvent'
import { EventList } from './components/EventList/EventList'
import { PointList } from './components/PointList/PointList'
import css from './PointAndEventPanel.module.scss'

export const LocEventPanel = () => {
  const { data: categories } = useGetCategoriesQuery()
  const { currentPoints: points } = useAppSelector((state) => state.points)
  const { currentEvents: events } = useAppSelector((state) => state.events)

  const {
    isSideBarCloseInitiated,
    isNewEventFormOpened,
    isEditEventFormOpened,
    isEventInfoOpened,
    isEventListOpened,
  } = useAppSelector((state) => state.app)
  const { closeSideBar } = useSideBarControlls()

  useEffect(() => {
    if (isSideBarCloseInitiated) closeSideBar()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSideBarCloseInitiated])

  const { setMultiSwitchValue } = useActions()
  const { currentTabSelected } = useAppSelector((state) => state.app)
  const { selectedEvent } = useAppSelector((state) => state.events)

  const onMultiSwitchChange = (newValueMultiSwitch: string) => {
    setMultiSwitchValue(newValueMultiSwitch)
  }

  useEffect(() => {
    if (currentTabSelected === 'events') {
      amplTrack({ name: 'map_events_view' })
    }
  }, [currentTabSelected])

  return (
    <div className={css.eventsViewContainer}>
      {((currentTabSelected === 'locations' && points) ||
        (currentTabSelected === 'events' && isEventListOpened && events)) && (
        <FlexRow
          vPadding="12"
          spacing="12"
          cx={css.multiSwitchWrapper}
          padding="24"
        >
          <MultiSwitch
            items={[
              { id: 'locations', caption: 'Places' },
              { id: 'events', caption: 'Events' },
            ]}
            value={currentTabSelected}
            onValueChange={onMultiSwitchChange}
          />
        </FlexRow>
      )}
      {currentTabSelected === 'events' && isNewEventFormOpened && (
        <NewEventForm />
      )}
      {currentTabSelected === 'events' &&
        isEditEventFormOpened &&
        selectedEvent && (
          <EventEditForm event={getExtendedEvent(selectedEvent, categories)} />
        )}
      {currentTabSelected === 'events' &&
        isEventInfoOpened &&
        selectedEvent && <EventInfo event={selectedEvent} />}
      {currentTabSelected === 'events' && isEventListOpened && events && (
        <EventList events={events} categories={categories} />
      )}
      {currentTabSelected === 'locations' && points && (
        <PointList points={points} categories={categories} />
      )}
    </div>
  )
}
